module.exports = __webpack_public_path__ + "img/8B892C_D4E856_475E2D_47360A-256px.03397336.png";